import React, {useEffect, useState} from 'react'
import config from '../../config/config.json';
import OlaLoader from '../Loader';
import Axios from '../../helpers/axios';
import { useHistory, useParams } from 'react-router';
import { retrieveUri } from '../../helpers/utils';
import {useLocation} from "react-router-dom";
import { useCookies } from 'react-cookie';

export default function AppLogin(props){

    const [loading, setLoading] = useState(true)
    const history = useHistory()
    let { appId, tenantId } = useParams()
    const [cookies, setCookie, removeCookie] = useCookies(['color_scheme_id']);

    const search = useLocation().search;
    const origin = new URLSearchParams(search).get('origin');

    console.log("props.match.params", new URLSearchParams(search))

    let params = {}

    if(origin == 'home'){
      params = {
        origin: 'home'
      }
    }

    useEffect(()=> {
        Axios.get(config.server.basePath + config.server.serviceProviderLoginPath.replace("{tenant_id}", tenantId).replace("{app_id}", appId), 
          {
            params: params
          })
        .then((response)=>{
            setLoading(false)
        if(response.status === 200){
          if(response.headers["content-type"].includes("text/html")){
            history.push(config.pageUri.confirmationForm, {data: response.data})
          }
          else if(response.data.is_logged_in){
            history.push(config.pageUri.home, {authenticated: true})
          }
          else if(!response.data.is_logged_in){
            history.push(retrieveUri(response.data.policy_page_url));
          }
        }
    }).catch((error)=>{
      setLoading(false)
      console.log("applogin ",error.response);
      history.push(config.pageUri.error, {status: error.response.status, statusText: error.response.statusText, headers: error.response.headers, errorData : error.response.data})
    })
    }, [])
    
    if(loading)
      if(cookies.color_scheme_id != 3)
        return (
          <div className="loader-style">
            <OlaLoader />
            {/* <div className="text-center">
              Signing In...
            </div> */}
          </div>
        )
      else
        return (
          <div className="loader-style" style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, backgroundColor: '#111'}}>
            <OlaLoader dark/>
            {/* <div className="text-center">
              Signing In...
            </div> */}
          </div>
        ) 
    return <></>
}